import React, {useEffect, useRef, useState} from 'react';
import './animatedCounter.css';

export default function AnimatedCounter({end, suffix = '', duration = 1500}){
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);
  const startRef = useRef(null);

  useEffect(()=>{
    const start = performance.now();
    startRef.current = start;
    const initial = 0;

    function step(now){
      const t = Math.min(1, (now - start) / duration);
      const eased = t<0.5 ? 2*t*t : -1 + (4-2*t)*t; // easeInOutQuad-ish
      const current = Math.floor(initial + (end - initial) * eased);
      setValue(current);
      if(t < 1) rafRef.current = requestAnimationFrame(step);
      else setValue(end);
    }

    rafRef.current = requestAnimationFrame(step);
    return ()=> cancelAnimationFrame(rafRef.current);
  },[end,duration]);

  return (
    <div className="animated-counter">{value}{suffix}</div>
  );
}
